import { render, staticRenderFns } from "./servicios-huerfanos-aviso.vue?vue&type=template&id=1a27a092&scoped=true"
import script from "./servicios-huerfanos-aviso.vue?vue&type=script&lang=js"
export * from "./servicios-huerfanos-aviso.vue?vue&type=script&lang=js"
import style0 from "./servicios-huerfanos-aviso.vue?vue&type=style&index=0&id=1a27a092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a27a092",
  null
  
)

export default component.exports